import React from 'react';

import { useIntl } from 'react-intl-next';

import DateFilterWithCustomRangePicker from '../../../../../common/ui/filters/last-modified-filter';
import { useSelectFilter } from '../../../../../controllers/filters';
import { filter as lastUpdatedFilter } from '../../../../../controllers/store/search/filters/last-updated';

import { i18n } from './messages';

const LastUpdatedFilter = () => {
	const { formatMessage } = useIntl();

	const [filterData, { setOption, loadInitialOptions }] = useSelectFilter({
		filterId: lastUpdatedFilter.id,
	});

	if (!filterData) {
		return null;
	}

	const { options, selectedOptions, customValue } = filterData;

	return (
		<DateFilterWithCustomRangePicker
			options={options}
			onSelectChange={setOption}
			label={formatMessage(i18n.lastUpdated)}
			onDropdownOpen={loadInitialOptions}
			selectedOptions={selectedOptions}
			customDateRange={customValue || { from: '', to: '' }}
			testId="universal-last-updated-filter"
		/>
	);
};

export default LastUpdatedFilter;
